var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"market-trading-unavailable-v2__icon"}),_vm._v(" "),_c('div',{staticClass:"market-trading-unavailable-v2__text"},[_vm._t("text")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-282d136a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/market/v2/market-trading-unavailable-v2/market-trading-unavailable-v2.vue
// module id = yOrf
// module chunks = 0